module.exports = __webpack_public_path__ + "img/3.670f394c.png";